export default __webpack_public_path__ + "static/error-404-114cc84c318964a05126b3176598292b.png";